/**
 * 路由：菜谱管理 + 自动配菜（首页重定向到配菜页）
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import RecipeManage from '../views/RecipeManage.vue'
import MenuGenerate from '../views/MenuGenerate.vue'
import HistoryMenus from '../views/HistoryMenus.vue'
import MenuPreview from '../views/MenuPreview.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/generate'
  },
  {
    path: '/generate',
    name: 'MenuGenerate',
    component: MenuGenerate
  },
  {
    path: '/recipes',
    name: 'RecipeManage',
    component: RecipeManage
  },
  {
    path: '/history',
    name: 'HistoryMenus',
    component: HistoryMenus
  },
  {
    path: '/history/preview/:id',
    name: 'MenuPreview',
    component: MenuPreview
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
